module.exports = __webpack_public_path__ + "782cac04a9bd2cb32c699e0b5e36313f.jpg";